@if (categories) {
  <swiper-container [sale4AllSwiper]="config" init="false" dir="rtl">
    @for (category of categories; track category) {
      <swiper-slide>
        <mat-card appearance="outlined" class="product-item myProductItem">
          <!--                <mat-chip-list *ngIf="product.discount">-->
          <!--                    <mat-chip color="warn" selected="true">{{product.discount}}% OFF</mat-chip>-->
        <!--                </mat-chip-list>-->
        <a [routerLink]="['/categories', category.id, category.name.replace(' ','-')]" class="image-link">
          @if (categories) {
            <img style="height: 250px; object-fit: cover;" [src]="category.image" [alt]="category.name" loading="lazy"/>
          }
        </a>
        <!--                <h4 class="category text-muted">{{ category?.description }}</h4>-->
        <a [routerLink]="['/categories', category.id, category.name.replace(' ','-')]" class="title text-truncate ">
          <span class="titleCategory">{{category.name}}</span>
        </a>
      </mat-card>
    </swiper-slide>
  }
  <button aria-label="הקודם" mat-mini-fab class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
  <button aria-label="הבא" mat-mini-fab class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
</swiper-container>
}
